import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const c = (r) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(r),
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_3629_11201)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            d: "M13.0001 11.0022V13.0022H23C23.5523 13.0022 24 12.5545 24 12.0022C24 11.45 23.5523 11.0022 23 11.0022H13.0001Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M11.0001 13.0022V11.0022H1C0.447715 11.0022 0 11.45 0 12.0022C0 12.5545 0.447715 13.0022 1 13.0022H11.0001Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0001 0C11.4478 0 11.0001 0.447716 11.0001 1V11.0022H13.0001V1C13.0001 0.447715 12.5524 0 12.0001 0ZM13.0001 13.0022H11.0001L11.0001 23C11.0001 23.5523 11.4478 24 12.0001 24C12.5524 24 13.0001 23.5523 13.0001 23L13.0001 13.0022Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M13.0001 13.0022V11.0022H11.0001V13.0022H13.0001Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3629_11201", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  c as AddIcon
};
//# sourceMappingURL=AddIcon.js.map
